import React, {useEffect, useState} from 'react';
import {Col, Modal, notification, Row, Spin} from "antd";
import '../modals.css';
import {companyService} from "../../../services";
import i18n from "../../../i18n";

export default function ModalShowRefuseReasonForConsignor({isShow, setIsShow, id}) {

  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});

  useEffect(() => {
    setLoading(true);
    if (id && isShow) {
      companyService
        .getRefuseReasonInfo(id)
        .then(resp => {
          setInfo(resp);
          setLoading(false);
        })
        .catch(errMsg => notification.error(
          {
            message: i18n.t('components.notification.titles.getRefuseReasonInfo'),
            description: errMsg
          }));
    }
  }, [id, isShow]);

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('modals.modalShowRefuseReasonForConsignor.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={null}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered" style={{fontSize: "14px"}}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.legalEntityName.title')}:</b> {info.legalEntityName}</Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.consignorName.title')}:</b> {info.consignorName}</Col>
        </Row>
        <Row className="add-padding-10 -centered" style={{fontSize: "14px", paddingBottom: 40}}>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.status.title')}:</b> {info.status}</Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.dateCreated.title')}:</b> {info.dateCreated}</Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.refuseDate.title')}:</b> {info.refuseDate}</Col>
          <Col span={24}><b>{i18n.t('modals.modalShowRefuseReasonForConsignor.fields.refuseReason.title')}: </b>
            <p>{info.refuseReason}</p>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}
